// The phone's copy of the worker's chat limit (RATE_LIMITS.chat, BE-13). The gateway drops a chat
// frame past its bucket without a word and counts it towards closing the socket, so the phone holds
// the line back itself and shows the wait as a countdown on Send. The worker stays the judge; this
// only keeps a thumb from tripping it. Pure: the caller passes the clock.
import { RATE_LIMITS } from '@wahala/protocol';

/** Refill a little slower than the worker does, so lines that bunch up on the way still fit. */
const MARGIN = 0.75;

export class ChatGate {
  private tokens: number;
  private at: number;

  constructor(
    now: number,
    private readonly burst: number = RATE_LIMITS.chat,
    private readonly perSecond: number = RATE_LIMITS.chat * MARGIN,
  ) {
    this.tokens = burst;
    this.at = now;
  }

  private refill(now: number): void {
    this.tokens = Math.min(this.burst, this.tokens + (Math.max(0, now - this.at) / 1000) * this.perSecond);
    this.at = now;
  }

  /** Spend one line if there is one to spend. */
  take(now: number): boolean {
    this.refill(now);
    if (this.tokens < 1) return false;
    this.tokens -= 1;
    return true;
  }

  /** Milliseconds until the next line may go (0 when one may go now). */
  waitMs(now: number): number {
    this.refill(now);
    return this.tokens >= 1 ? 0 : Math.ceil(((1 - this.tokens) / this.perSecond) * 1000);
  }
}

/** Whole seconds for the countdown on Send: never 0 while there is still a wait. */
export const waitSeconds = (ms: number): number => (ms > 0 ? Math.max(1, Math.ceil(ms / 1000)) : 0);
